import React from 'react';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLink from '../../../../library/form/components/FormLink';
import FormButton from '../../../../library/form/components/FormActionButton2';

const TransportPaymentRow = (props) => {
    const { formObject, rowKey } = props;
    return (
        <tr>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "rowId" }} />
            </td>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "transportDate" }} />
            </td>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "transportID" }} />
            </td>
            <td >
                <FormLink formObject={formObject} rowKey="" className="uiLink"
                    action={{ paramName: "vehicleNumber", actionId: "show",  containerKey: "popup" }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </td>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "fromPort" }} />
            </td>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "toPort" }} />
            </td>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "weight" }} />
            </td>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "ktCharges" }} />
            </td>
            <td >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "amount" }} />
            </td>
            <td className="uiActionBlock" >
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                    className="" ></FormButton>
            </td>
        </tr>
    )
}

export default TransportPaymentRow